import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllCarSubModelsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  nameIcontains?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type AllCarSubModelsQuery = { __typename?: 'Query', allCarSubModels?: { __typename?: 'CarSubModelNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CarSubModelNodeEdge', cursor: string, node?: { __typename?: 'CarSubModelNode', id: string, name: string, localName?: string | null } | null } | null> } | null };


export const AllCarSubModelsDocument = gql`
    query AllCarSubModels($offset: Int, $before: String, $after: String, $first: Int, $last: Int, $nameIcontains: String) {
  allCarSubModels(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    nameIcontains: $nameIcontains
  ) {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        name
        localName
      }
      cursor
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAllCarSubModelsQuery__
 *
 * To run a query within a React component, call `useAllCarSubModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCarSubModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCarSubModelsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      nameIcontains: // value for 'nameIcontains'
 *   },
 * });
 */
export function useAllCarSubModelsQuery(baseOptions?: Apollo.QueryHookOptions<AllCarSubModelsQuery, AllCarSubModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCarSubModelsQuery, AllCarSubModelsQueryVariables>(AllCarSubModelsDocument, options);
      }
export function useAllCarSubModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCarSubModelsQuery, AllCarSubModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCarSubModelsQuery, AllCarSubModelsQueryVariables>(AllCarSubModelsDocument, options);
        }
export type AllCarSubModelsQueryHookResult = ReturnType<typeof useAllCarSubModelsQuery>;
export type AllCarSubModelsLazyQueryHookResult = ReturnType<typeof useAllCarSubModelsLazyQuery>;
export type AllCarSubModelsQueryResult = Apollo.QueryResult<AllCarSubModelsQuery, AllCarSubModelsQueryVariables>;